import React from 'react';
import { StaticQuery, graphql } from 'gatsby';

const Call = props => (
  <div className="call">
    <div className="call-box-top">
    <h4>Jetzt Kontakt aufnehmen:</h4>
      <div className="call-phone">
        <strong>Phone: </strong>
        <a href="tel:+4922646035">
          {props.data.site.siteMetadata.contact.phone}
        </a>
      </div>
      
    </div>
    {props.button && (
      <div className="call-box-bottom">
        <a href={`mailto:${props.data.site.siteMetadata.contact.email}`} className="button">
          Email Anfrage
        </a>
      </div>
    )}
  </div>
);

export default props => (
  <StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            title
            description
            contact {
              email
              phone
            }
          }
        }
      }
    `}
    render={data => <Call button={props.button} data={data} />}
  />
);
